export default __webpack_public_path__ + "static/media/ic_notification_package.4d3de604.svg";